import React from 'react'
import ReactDOM from 'react-dom/client'
import ReactPixel from 'react-facebook-pixel'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router'
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { store } from './store'
import { ThemeProvider } from './theme'






const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(    g))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
